import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNumbaComponent } from './simple-icons-numba.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNumbaComponent ],
    exports:      [ SimpleIconsNumbaComponent ],
    bootstrap:    []
})
export class SimpleIconsNumbaModule {}
